import { useWindowDimensions } from "react-native";
import { useMemo } from "react";

const WEB_MENU_WIDTH = 240;
const TABLET_MENU_WIDTH = 155;

export const useDimensions = () => {
  const { width, height } = useWindowDimensions();

  const webWidthContent = useMemo(() => width - WEB_MENU_WIDTH, [width]);
  const tabletWidthContent = useMemo(() => width - TABLET_MENU_WIDTH, [width]);

  const isMobile = useMemo(() => width < 768, [width]);
  const isTablet = useMemo(() => width >= 768 && width <= 1024, [width]);
  const isWeb = useMemo(() => width > 1024, [width]);

  const isResponsive = useMemo(
    () => isMobile || isTablet,
    [isMobile, isTablet]
  );
  const isTabletOrWeb = useMemo(() => isTablet || isWeb, [isTablet, isWeb]);

  return {
    webWidthContent,
    tabletWidthContent,
    WEB_MENU_WIDTH,
    TABLET_MENU_WIDTH,
    width,
    height,
    isMobile,
    isTablet,
    isWeb,
    isTabletOrWeb,
    isResponsive
  };
};
